import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsUsers from './SettingsUsers';

function UsersPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Users & Access"
        subtitle="Manage user accounts and access"
        backTo="/settings/users-and-permissions"
        backLabel="Users & Permissions"
        sticky
      />
      <main className="max-w-7xl mx-auto px-6 py-8">
        <SettingsUsers />
      </main>
    </div>
  );
}

export default UsersPage;
